exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  font-size: 11px;\n  background-color: #f85045;\n  padding: 2px 6px;\n  border-radius: 3px 3px 0 0;\n  margin-left: 2px;\n  width: 300px;\n  display: block;\n  color: #fff;\n}\n#current_password {\n  display: block;\n}", ""]);

// exports
